import { render } from "./signatures.vue?vue&type=template&id=718e442e"
import script from "./signatures.vue?vue&type=script&lang=ts"
export * from "./signatures.vue?vue&type=script&lang=ts"
script.render = render

export default script